import type { IWorkItemOption } from '../../../types';

export enum ERuleType {
  Market = 'MRKT',
}

export enum ERuleStrategy {
  Inclusive = 'Inclusive',
  Exclusive = 'Exclusive',
}

export enum ERuleSaveStatus {
  Inprogress = 'P',
  Success = 'S',
  Failed = 'F',
  Partial = 'W',
}

export enum EWorkItemType {
  Master = 'Master',
  WorkItem = 'WorkItem',
}

export enum EWorkItemStatus {
  InProgress = 'InProgress',
}

export const Master: IWorkItemOption = { id: '0', name: 'Master' };

export const ProcosTabs = [
  { id: 'product', name: 'labels.product', path: '' },
  { id: 'option', name: 'labels.option', path: 'features' },
];

export const DefaultProcosTab = 'procos';

export enum EPackageType {
  Release = 'R',
  Internal = 'I',
}
